import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "px-4 sm:px-6 lg:px-8" };
const _hoisted_2 = { class: "mt-8 flex flex-col" };
const _hoisted_3 = { class: "-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8" };
const _hoisted_4 = { class: "inline-block min-w-full py-2 align-middle md:px-6 lg:px-8" };
const _hoisted_5 = { class: "overflow-hidden shadow border border-gray-200 md:rounded-lg" };
const _hoisted_6 = { class: "min-w-full divide-y divide-gray-300 border-b-1 border-b-gray-300" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("thead", { class: "bg-gray-50" }, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", {
            colspan: "2",
            scope: "col",
            class: "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
        }, "\n                    Profile\n                  ")
    ])
], -1);
const _hoisted_8 = { class: "divide-y divide-gray-200 bg-white" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("td", { class: "whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6" }, "\n                    ID\n                  ", -1);
const _hoisted_10 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" };
const _hoisted_11 = { key: 0 };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("td", { class: "whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6" }, "\n                    Name\n                  ", -1);
const _hoisted_14 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("td", { class: "whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6" }, "\n                    Email Address\n                  ", -1);
const _hoisted_16 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("td", { class: "whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6" }, "\n                    Roles\n                  ", -1);
const _hoisted_18 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" };
const _hoisted_19 = { key: 0 };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_21 = { key: 1 };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_23 = { key: 2 };
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_25 = { key: 3 };
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_27 = { key: 4 };
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("td", { class: "whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6" }, "\n                    Mailing preferences\n                  ", -1);
const _hoisted_29 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" };
const _hoisted_30 = { class: "pl-5 mt-4 pt-4 pb-4 border border-grey-200 border-t-1 border-l-0 border-r-0 border-b-0" };
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("label", { class: "text-base font-medium text-gray-900" }, "Mailing preferences", -1);
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm leading-5 text-gray-500" }, "How do you prefer to receive emails?", -1);
const _hoisted_33 = { class: "mt-4" };
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("legend", { class: "sr-only" }, "Mailing preferences", -1);
const _hoisted_35 = { class: "space-y-4" };
const _hoisted_36 = { class: "flex items-center" };
const _hoisted_37 = ["checked"];
const _hoisted_38 = /*#__PURE__*/ _createElementVNode("label", {
    for: "notification-method",
    class: "ml-3 block text-sm font-medium text-gray-700"
}, "\n                      NO EMAILS\n                    ", -1);
const _hoisted_39 = { class: "flex items-center" };
const _hoisted_40 = ["checked"];
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("label", {
    for: "notification-method",
    class: "ml-3 block text-sm font-medium text-gray-700"
}, "\n                      INSTANT\n                    ", -1);
import { Auth } from 'aws-amplify';
import { computed, onBeforeMount, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import httpClient from '@/httpClient';
export default /*#__PURE__*/ _defineComponent({
    __name: 'profileView',
    setup(__props) {
        const store = useStore();
        store.dispatch('setIsLoading', true);
        const user = ref({});
        const updateMailing = async () => {
            try {
                const userID = Auth.user.signInUserSession.idToken.payload.identities[0].userId.split('@')[0];
                const response = await httpClient.post('/users/update-user', {
                    userID: userID,
                    emailPrefs: mailing.value,
                });
                user.value = response.data.body.Attributes;
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'success',
                    title: 'Success!',
                    message: 'Email Preferences updated.',
                });
            }
            catch {
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'error',
                    title: 'ERROR!',
                    message: 'Could not get user profile data.',
                });
            }
        };
        const userProfile = computed(() => {
            return {
                ...Auth?.user.signInUserSession.idToken.payload,
                ...user.value,
            };
        });
        const mailing = ref(userProfile.value.emailPrefs);
        const onChange = (event) => {
            const target = event.target;
            mailing.value = target.value;
        };
        const fetchUser = async () => {
            try {
                const userID = Auth.user.signInUserSession.idToken.payload.identities[0].userId.split('@')[0];
                const response = await httpClient.post('/users/user', { userID });
                user.value = response.data.body?.Item ?? {};
            }
            catch {
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'error',
                    title: 'ERROR!',
                    message: 'Could not get user profile data.',
                });
            }
        };
        onBeforeMount(async () => {
            await fetchUser();
        });
        onMounted(() => store.dispatch('setIsLoading', false));
        watch(() => userProfile.value.emailPrefs, (newVal) => {
            mailing.value = newVal;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("table", _hoisted_6, [
                                    _hoisted_7,
                                    _createTextVNode(),
                                    _createElementVNode("tbody", _hoisted_8, [
                                        _createElementVNode("tr", null, [
                                            _hoisted_9,
                                            _createTextVNode(),
                                            _createElementVNode("td", _hoisted_10, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userProfile.value.identities, (id) => {
                                                    return (_openBlock(), _createElementBlock("span", { key: id }, [
                                                        _createTextVNode(_toDisplayString(id.userId) + " ", 1),
                                                        (userProfile.value.identities.indexOf(id) < userProfile.value.identities.length - 1)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                                                _createTextVNode("\n                        ,"),
                                                                _hoisted_12
                                                            ]))
                                                            : _createCommentVNode("", true)
                                                    ]));
                                                }), 128))
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("tr", null, [
                                            _hoisted_13,
                                            _createTextVNode(),
                                            _createElementVNode("td", _hoisted_14, _toDisplayString(userProfile.value.given_name) + " " + _toDisplayString(userProfile.value.family_name), 1)
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("tr", null, [
                                            _hoisted_15,
                                            _createTextVNode(),
                                            _createElementVNode("td", _hoisted_16, _toDisplayString(userProfile.value.email), 1)
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("tr", null, [
                                            _hoisted_17,
                                            _createTextVNode(),
                                            _createElementVNode("td", _hoisted_18, [
                                                (userProfile.value.H2R)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                                        _createTextVNode("Hire 2 Retire"),
                                                        _hoisted_20
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                _createTextVNode(),
                                                (userProfile.value.ADMIN)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                                        _createTextVNode("Admin"),
                                                        _hoisted_22
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                _createTextVNode(),
                                                (userProfile.value.HROPS)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                                                        _createTextVNode("HROPS"),
                                                        _hoisted_24
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                _createTextVNode(),
                                                (userProfile.value.HM)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                                        _createTextVNode("Hiring Manager"),
                                                        _hoisted_26
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                _createTextVNode(),
                                                (userProfile.value.RESOURCING)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Resourcing"))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("tr", null, [
                                            _hoisted_28,
                                            _createTextVNode(),
                                            _createElementVNode("td", _hoisted_29, _toDisplayString(userProfile.value.emailPrefs), 1)
                                        ])
                                    ])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_30, [
                                    _hoisted_31,
                                    _createTextVNode(),
                                    _hoisted_32,
                                    _createTextVNode(),
                                    _createElementVNode("fieldset", _hoisted_33, [
                                        _hoisted_34,
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_35, [
                                            _createElementVNode("div", _hoisted_36, [
                                                _createElementVNode("input", {
                                                    id: "email-prefs-none",
                                                    value: "NO-EMAILS",
                                                    name: "notification-method",
                                                    type: "radio",
                                                    checked: 'NO-EMAILS' === userProfile.value.emailPrefs,
                                                    class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300",
                                                    onChange: _cache[0] || (_cache[0] = ($event) => (onChange($event)))
                                                }, null, 40, _hoisted_37),
                                                _createTextVNode(),
                                                _hoisted_38
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_39, [
                                                _createElementVNode("input", {
                                                    id: "email-prefs-instant",
                                                    value: "INSTANT",
                                                    name: "notification-method",
                                                    type: "radio",
                                                    checked: ['INSTANT', 'NONE'].includes(userProfile.value.emailPrefs),
                                                    class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300",
                                                    onChange: _cache[1] || (_cache[1] = ($event) => (onChange($event)))
                                                }, null, 40, _hoisted_40),
                                                _createTextVNode(),
                                                _hoisted_41
                                            ])
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("button", {
                                        type: "submit",
                                        class: "mt-5 bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                                        onClick: updateMailing
                                    }, "\n                  Save\n                ")
                                ])
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
